import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const { ids, clear } = useWishlist();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (ids.length === 0) { setProducts([]); setLoading(false); return; }
    setLoading(true);
    Promise.all(ids.map((id) => api.get(`/products/${id}`).then((r) => r.data).catch(() => null)))
      .then((rows) => { setProducts(rows.filter(Boolean)); setLoading(false); });
  }, [ids]);

  return (
    <div data-testid="wishlist-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
      <div className="text-xs tracking-[0.3em] uppercase text-primary font-semibold mb-4">◦ Saved for later</div>
      <div className="flex items-end justify-between mb-12">
        <h1 className="font-serif text-4xl lg:text-5xl tracking-tight">
          {ids.length === 0 ? "No favourites yet." : `${ids.length} saved ${ids.length === 1 ? "piece" : "pieces"}.`}
        </h1>
        {ids.length > 0 && (
          <button onClick={clear} data-testid="wishlist-clear" className="text-xs tracking-[0.2em] uppercase text-muted-foreground hover:text-destructive font-semibold transition-colors">
            Clear all
          </button>
        )}
      </div>
      {loading ? (
        <div className="text-muted-foreground">Loading…</div>
      ) : ids.length === 0 ? (
        <div className="border border-border p-16 text-center rounded-sm bg-card">
          <Heart className="w-8 h-8 text-primary mx-auto mb-4" strokeWidth={1.5} />
          <p className="text-muted-foreground mb-8">Tap the heart on any piece to save it here.</p>
          <Link to="/shop" className="btn-primary inline-block px-7 py-3.5 text-sm rounded-sm">Visit the shop</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
